import React from 'react'
import Form from '../../components/Form'
import fields, { DisableFormData } from './fields'
import { handleFormSubmit, useRequest, useAuth } from '@polvo-labs/react-auth'
import { toast } from 'react-toastify'

interface Props {
  onSubmit: () => void
}

const DisableForm: React.FC<Props> = ({ onSubmit }) => {
  const { user } = useAuth()
  const { request } = useRequest()

  return (
    <Form<DisableFormData>
      buttonLabel="ENVIAR"
      fields={fields}
      onSubmit={data => handleFormSubmit({
        request: request({
          method: 'PUT',
          url: `${process.env.REACT_APP_API_URL}/user/disable`,
          data,
        }),
        onValidationErrors: () => toast.error('Erros de validacao.'),
        onSuccess: () => {
          toast.success('Seus dados foram atualizados com sucesso.')
          onSubmit()
        },
        onFailure: () => toast.error('Erro ao alterar informações.'),
      })}
    />
  )
}

export default DisableForm
